<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1 text-sm">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-1 px-4">
            <h5 class="text-sm">
              {{ client.name }} <span class="text-gray-600">({{ client.code }})</span>
            </h5>
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0 text-right">{{ client.balance }} &euro;</div>

          <div class="w-32 px-4 mt-4 lg:mt-0 text-right">{{ client.creditLimit }} &euro;</div>

          <div class="w-32 px-4 mt-4 lg:mt-0 text-right">{{ remainingCreditLimit }} &euro;</div>

          <div class="hidden lg:block w-48 lg:text-right px-4">
            {{ dateCreated }}
          </div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <button
          :disabled="!client.can.view || disabled"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
          @click="$emit('client:view', client)"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    client: { type: Object, required: true },
    disabled: Boolean,
  },

  computed: {
    remainingCreditLimit() {
      return (this.client.creditLimit - this.client.balance).toFixed(2);
    },
    dateCreated() {
      return moment(this.client.created_at).format('DD/MM/YYYY');
    },
  },
};
</script>
